import { useDisconnect as useWagmiDisconnect } from "wagmi";

import { useStoreDispatch } from "../store/store";


export const useDisconnect = () => {
	const { disconnectAsync } = useWagmiDisconnect();
	const { clearAppState, clearChrState, clearModalsState, clearUIState } = useStoreDispatch();

	const disconnect = async () => {
		// console.log('account disconected');
		await disconnectAsync();
		// setTimeout(() => {
			clearAppState();
			clearChrState();
			clearModalsState();
			clearUIState();
		// })
	};


	return disconnect;
}